import React from "react";
import styles from "../../../../CSS/ui/PricingCard.module.css";
import Button from "../Button";

/**
 * What each public plan does and doesn't include, shown under the plan name.
 *
 * Keyed by plan name because that is what the pricing API returns and what the
 * built-in entitlement rule keys off too (PlanEntitlements: new Lite/Pro lose
 * commercial properties and the Investor Portfolio; weather is Pro and Legend).
 *
 * Enterprise is deliberately absent: its capabilities are negotiated per
 * agreement, so there is no single true line to print for it.
 */
const PLAN_NOTES = {
  "Rhino Lite":
    " | weather data, commercial properties and portfolios not included",
  "Rhino Pro":
    " | weather data included | commercial properties and portfolios not included",
  "Rhino Legend":
    " | weather data, commercial properties, and portfolios included",
};

const getPlanNote = (planName) => PLAN_NOTES[planName] || "";

const PricingCard = ({ content }) => {
  const {
    id,
    name,
    price,
    billingCycle,
    credits,
    users,
    creditsNote,
    cta,
    highlight,
    description,
    annualPlan,
  } = content;
  return (
    <>
      <div
        className={`${styles.pricingCard} ${highlight && styles.highlightCard}`}
      >
        <div className={styles.contentCard}>
          <h4
            className={`heading4 mb-1 font-regular ${
              highlight ? "text-yellow" : "text-black"
            }`}
          >
            {name}
          </h4>
          <p
            className={`${styles.planMeta} ${
              highlight ? "text-lightgray " : "text-gray"
            }`}
            style={{ marginBottom: 13 }}
          >
            {credits} credits | {users} user{users > 1 || users === "Custom" ? "s" : ""}{annualPlan && " | " + annualPlan}{getPlanNote(name)}
          </p>
          <p
            className={`p12 mb-0 ${
              highlight ? "text-lightgray " : "text-gray"
            }`}
            // style={{maxWidth: 140}}
          >
            {creditsNote}
          </p>
        </div>
        <div
          className={`${
            price && billingCycle
              ? "d-flex flex-column flex-lg-row justify-content-between"
              : "d-flex flex-column justify-content-between gap-1"
          } ${styles.priceBtn}`}
        >
          {price && billingCycle && (
            <h3
              className={`${styles.heading3} font-semibold ${
                highlight ? "text-light " : "text-dark"
              } text-lowercase`}
            >
              ${price}/{billingCycle}
            </h3>
          )}
          <Button
            url={cta.url}
            label={cta.label}
            // variant={isOutlineLight ? "outline" : "solid"}
            // Use built-in defaults; override via props if needed
            bgColor={highlight ? "#EFE8D8" : "#B7A680"}
            // textColor={isOutlineLight ? "#fff" : undefined}
            // leftIcon={isOutlineLight ? Play : undefined}
            // rightIcon={isLight ? ArrowRight : undefined}
            className="" // spacing handled by component CSS
            target={cta?.target}
          />

          {description && <p className="p14 text-black mb-0">{description}</p>}
        </div>
      </div>
    </>
  );
};

export default PricingCard;